// Upload responses keep /api/uploads paths; static assets stay on the frontend.
export const resolveMediaUrl = (value, backendOrigin = process.env.REACT_APP_BACKEND_URL || '') => {
  if (!value || typeof value !== 'string') return '';
  const url = value.trim();
  if (/^(https?:|data:|blob:|\/\/)/i.test(url)) return url;
  if (url.startsWith('/api/')) return `${backendOrigin.replace(/\/+$/, '')}${url}`;
  return url;
};

// Exported HTML is used outside this website and needs an absolute image URL.
export const absoluteMediaUrl = (value, backendOrigin = process.env.REACT_APP_BACKEND_URL || '', pageOrigin = window.location.origin) => {
  const url = resolveMediaUrl(value, backendOrigin);
  if (!url) return '';
  return new URL(url, pageOrigin).href;
};

// Owned uploads can stay on the application server for canvas/email exports,
// even when normal image reads redirect to a separate R2 hostname.
export const resolveCanvasMediaUrl = (value, backendOrigin = process.env.REACT_APP_BACKEND_URL || '') => {
  const url = resolveMediaUrl(value, backendOrigin);
  if (!url) return '';
  const parsed = new URL(url, window.location.origin);
  const apiOrigin = new URL(backendOrigin || window.location.origin, window.location.origin).origin;
  if (parsed.origin === apiOrigin && parsed.pathname.startsWith('/api/uploads/')) {
    parsed.searchParams.set('proxy', 'true');
    return parsed.href;
  }
  return url;
};
